/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const DEFAULT_LOCALE = 'en';

export default new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: 'en',
  messages: {
    'en': require('./locales/json/en.i18n.json'),
    'zh-CN': require('./locales/json/zh-CN.i18n.json')
  }
});

export const changeLanguageMixin = {
  methods: {
    changeLanguage(language) {
      language = language || DEFAULT_LOCALE;
      let locale = language.toLowerCase() === 'zh-cn' ? 'zh-CN' : language.toLowerCase();
      this.$i18n.locale = locale;
      this.$moment.locale(locale);
    }
  }
};
